<template>
  <div class="pump-retrieve-form">
    <v-paragraph class="pump-retrieve-form__heading"> Reparatie aanvragen </v-paragraph>
    <v-paragraph>{{ data.pumpDesc }} {{ data.serialNo }}</v-paragraph>
    <div class="row">
      <div class="col-md-6">
        <p class="text-black font-bold m-0 px-2 py-2">Ophaaldatum*</p>
        <v-input-date-picker
          class="px-2 py-2 ga-track-btn ga-track-pickup_date"
          id="pumpMaintenanceDate"
          ref="date"
          type="date"
          name="pumpMaintenanceDate"
          autofocus
          disable-dates
          disable-past-dates
          :overwrite-value="maintenanceDate"
          :disable-dates-for-pump-pickup="disableDatesForPickUp"
          :smallest-date="smallestDate"
          :dates-by-postalcode="differentPickupDates"
          @update-validation="updatePumpMaintenanceDate"
        />
      </div>
    </div>
     <div class="row">
      <div class="col-md-12">
        <div class="pump-retrieve-form__code">
          <v-input-group
            v-model="formConfig.ErrorCode.model"
            initvalue=""
            :rule="formConfig.ErrorCode.rule"
            :label="formConfig.ErrorCode.label"
            :inputid="formConfig.ErrorCode.ref"
          />
        </div>
      </div>
    </div> 
    <div class="row">
      <div class="col-md-12">
        <textarea
          id="remarks"
          class="pump-retrieve-form__textarea"
          placeholder="Opmerking (optioneel)"
          @input="setRemarks($event.target.value)"
        />
      </div>
    </div>
    <div class="row pump-retrieve-form__buttonsSection">
      <v-button md hollow transparent @click="cancelRetrievePump"> Annuleren </v-button>
      <v-button md primary @click.once="saveRetrievePump"> Bevestigen </v-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useForm } from 'vee-validate';
import { activePpwRecId$ } from '@/services';
import { ref } from 'vue';
import VInputDatePicker from '@/components/shared/form/simple/InputDatePicker';
import moment from 'moment';
import store from '@/store';

export default {
  name: 'VPumpretrieveform',
  components: { VInputDatePicker },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  setup() {
    const disableDatesForPickUp = ref('');
    const smallestDate = ref('');
    const differentPickupDates = ref('');
    const activePpwRecId = ref(null);
    const maintenanceDate = ref('');

    axios.get('Equipment/GetPostCode').then((response) => {
      if (response) {
        fetchDisableDatesForPostalCode(response.data);
      }
    })

    const updatePumpMaintenanceDate = (value) => {
      maintenanceDate.value = value;
    };

    const fetchDisableDatesForPostalCode = async (postalCode) => {
      if (postalCode && postalCode.length > 3) {
        let code = postalCode.split(' ')[0];
        if (code.length === 4) {
          let response = await getDisabledDatesForPumpsPickUp(code);
          if (response && response.data){
            let parsedunSelectedableDates = response.data.unSelectableDates.map(
            (dateElement) => new String(moment(dateElement, "D-M-YYYY").format("MM-DD-YYYY"))
          );
            disableDatesForPickUp.value = parsedunSelectedableDates;
            const parsedSmallestDate = moment(response.data.smallestDate).format('MM-DD-YYYY')
            smallestDate.value = parsedSmallestDate;
            maintenanceDate.value = parsedSmallestDate;
            differentPickupDates.value = true;
          }
        }
      }
    };

    const getDisabledDatesForPumpsPickUp = (value) =>
      store.dispatch('pumpOverview/getUnSelectableDatesForPostalCode', value);

    activePpwRecId$.subscribe((value) => {
      activePpwRecId.value = value;
    });

    return {
      activePpwRecId,
      disableDatesForPickUp,
      smallestDate,
      differentPickupDates,
      maintenanceDate,
      updatePumpMaintenanceDate,
      fetchDisableDatesForPostalCode
    };
  },
  data() {
    const { validate } = useForm();

    return {
      validate,
      formConfig: {},
      isRepair: false,
      pumpData: {}
    };
  },
  computed: {},
  created() {
    this.setFormConfig();
    this.pumpData = {
      ErrorCode: '',
      Comment: '',
      SerialNo: this.data.serialNo,
      PumpID: this.data.equipmentID,
      PpwRecId: this.activePpwRecId,
      PickUpDate: ''
    };
  },
  methods: {
    moment(...args) {
      return moment(...args);
    },
    cancelRetrievePump() {
      this.$emit('closeModal');
    },
    saveRetrievePump() {
        this.validateAllFields();
        this.$emit('closeModal');
    },
    setFormConfig() {
      this.formConfig = {
        ErrorCode: {
          ref: 'ErrorCode',
          label: 'Foutcode op pomp',
          model: this.pumpData.ErrorCode,
          rule: {
            required: false
          },
          attached: true,
          error: false,
          errorMessage: 'Vul de foutcode in die op de pomp is weergegeven.'
        }
      };
    },
    async validateAllFields(elements) {      
      const result = await this.validate();
      this.pumpData['PickUpDate'] = moment(this.maintenanceDate, 'DD-MM-YYYY').format(
        'YYYY-MM-DD'
      );
      if (result.valid) {
        for (let key in this.pumpData) {
          if (this.formConfig.hasOwnProperty(key) && this.formConfig[key].model !== undefined) {
            this.pumpData[key] = this.formConfig[key].model;
          }
        }
         axios.post('Equipment/EmailToRetrievePump', this.pumpData).then((response) => {
            if (response) {
              this.$emit('success');
              this.$emit('closeModal');
            }
         });
      }
    },
    resetFormConfigValues() {
      for (let key in this.formConfig) {
        this.formConfig[key].model = undefined;
      }
    },
    setRemarks(remarks) {
      this.pumpData['Comment'] = remarks;
    }
  }
};
</script>
<style land="css">
.pump-retrieve-form .form-group.form-group--error input {
  border: 2px solid red;
}
.pump-retrieve-form .form-group {
  padding: 0px;
}
.pump-retrieve-form .form-group-simple label {
  font-size: 14px;
  font-weight: normal;
}
.pump-retrieve-form .form-group label {
  position: absolute;
  top: -20px;
  left: 10px;
  background: white;
  width: auto;
  padding: 5px;
  font-size: 12px;
  color: #484848;
}
.pump-retrieve-form .form-group--focused label {
  font-size: 12px;
  color: #484848;
  transform: none;
  width: auto;
  max-width: 100%;
}
.pump-retrieve-form .form-group--hasvalue label {
  font-size: 12px;
  color: #484848;
  transform: none;
  width: auto;
  max-width: 100%;
}
.pump-retrieve-form .form-group input {
  border-style: none;
  border: 2px solid #006983;
  border-radius: 5px;
  padding: 10px 0px 10px 15px;
  color: black;
  height: auto;
}
.pump-retrieve-form .form-group .form-group__details:before,
.pump-retrieve-form .form-group .form-group__details:after {
  background-color: transparent;
}
</style>
<style lang="scss" scoped>
.pump-retrieve-form {
  &__code {
    margin-top: 15px;
  }
  &__textarea {
    padding: 0px;
    min-height: 95px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    border: 1px solid $grayish-mega-dark;
    width: 100%;
    padding: 10px;
    margin: 10px 0px 30px 0px;
  }
  legend {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  &__heading {
    font-weight: 500;
    margin-bottom: 10px;
    font-size: 20px;
    line-height: 1.2;
    color: rgba(0, 0, 0, 0.87);
  }
  &__buttonsSection {
    float: right;
  }
}
</style>
